import React from 'react';
import PropTypes from 'prop-types';

export const ThunderIcon = ({ width = 8, height = 13, color = '#F8BF88', ...props }) => (
  <svg width={width} height={height} viewBox="0 0 8 13" {...props}>
    <path
      d="M7.502 4.645a.404.404 0 00-.352-.203H5.078L6.324.636A.438.438 0 006.27.271C6.202.162 6.067.108 5.945.108H2.668a.39.39 0 00-.38.285L.055 7.163a.438.438 0 00.054.366.404.404 0 00.325.163h2.438l-.312 4.766a.408.408 0 00.298.42c.04.014.082.014.109.014a.39.39 0 00.352-.217l4.198-7.638a.374.374 0 00-.014-.392z"
      fill={color}
      fillRule="nonzero"
    />
  </svg>
);

ThunderIcon.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  color: PropTypes.string
};

export default ThunderIcon;
